export enum MarketplacesListOptionType {
  Empty = '',
  Campaigns = 'Campaigns',
  CustomMarketplaces = 'Custom',
}
